<template>
  <div class="home">
    <BannerVue
      :imgurl="bannerObj.bannerImgURL"
      :text="bannerObj.text"
      big
    ></BannerVue>
    <DesVue></DesVue>
    <TabVue></TabVue>
    <Wwd></Wwd>
    <!-- <Gmap></Gmap> -->
    <!-- <ResourcesVue></ResourcesVue> -->
    <!-- <button1></button1>
    <button2></button2> -->
    <!-- <Map></Map> -->
  </div>
</template>

<script>
// import Map from "@/components/map/index.vue";
import BannerVue from "@/components/banner/index.vue";
import DesVue from "./des/index.vue";
import TabVue from "./tab/index.vue";
import Wwd from "./wahtwedo/index.vue";
import ResourcesVue from "./resources/index.vue";
import { getItem } from "@/utils/localStorage.js";
// import Gmap from "@/components/Gmap/index.vue";
// import button1 from "@/components/cmrbutton/type1.vue";
// import button2 from "@/components/cmrbutton/type2.vue";
export default {
  name: "home",
  components: {
    BannerVue,
    DesVue,
    TabVue,
    Wwd,
    ResourcesVue,
    // Gmap,
    // Map,
    // button1,
    // button2,
  },
  data() {
    return {
      bannerObj: {},
    };
  },
  mounted() {
    if (getItem("language") == "zh-cn") {
      this.bannerObj = {
        bannerImgURL: require("@/assets/images/header/home.png"),
        text: ["磁联万物  驱动世界"],
      };
    } else {
      this.bannerObj = {
        bannerImgURL: require("@/assets/images/header/home.png"),
        text: ["Connect & Drive With Magnetics"],
      };
    }
    if (getItem("screenType") == "mobile") {
      this.bannerObj.bannerImgURL = require("@/assets/images/header/home1.png");
    }
    localStorage.setItem("headerActive", "");
  },
};
</script>

<style lang="less" scoped>
.test {
  height: 1200px;
  background: url("@/assets/images/header/home1.png") no-repeat;
}
.box {
  background-image: url("data:image/jpg;base64,/9j/4QMZR...");
}
</style>
